import { KNOWN_HOSTS, DEFAULT_HOST, MOBILE_HOST } from '../config.js';

// True when running inside the native Android/iOS app (Capacitor), as opposed to
// a browser. Only ever true in the APK — web builds never see window.Capacitor.
function isNativeApp() {
  return typeof window.Capacitor == 'object' &&
    typeof window.Capacitor.isNativePlatform == 'function' &&
    window.Capacitor.isNativePlatform();
}

// Detect server address from the URL
export function detectServerAddress() {
  // Native app: assets are bundled (served from localhost), so window.location is
  // meaningless for the server — always talk to the production server.
  if (isNativeApp()) {
    return MOBILE_HOST;
  }
  let host = DEFAULT_HOST;
  if (typeof window.location == 'object') {
    if (window.location.protocol == 'file:' || window.location.hostname == 'localhost') {
      host = KNOWN_HOSTS.local;
    } else if (window.location.hostname) {
      host = window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    }
  }
  return host;
}

// Detect if the page is served over HTTPS.
export function isSecureConnection() {
  // Native app always uses a secure (wss://) connection to the production server.
  if (isNativeApp()) {
    return true;
  }
  if (typeof window.location == 'object') {
    return window.location.protocol == 'https:';
  }
  return false;
}

export function isLocalHost() {
  if (typeof window.location == 'object') {
    return window.location.hostname == 'localhost';
  }
  return false;
}
